<template>
  <v-navigation-drawer
    app
    class="app-drawer"
    :mini-variant.sync="mini"
    v-model="drawer"
    :dark="true"
    permanent
  >
    <v-list-item class="px-2">
      <v-btn
        icon
        @click.stop="mini = !mini"
      >
        <v-icon v-html="mini ? 'mdi-chevron-right' : 'mdi-chevron-left'"></v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <app-launcher />
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense class="pa-0">
        <template v-for="(item, key) in computeMenu">
          <!-- <template v-if="item.children && item.children.length > 0">
            <v-list-group :key="key" no-action :to="item.path">
              <template v-slot:prependIcon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" v-text="item.meta.icon" />
                  </template>
                  <span>
                    {{ $vuetify.lang.t('$vuetify.menu.' + item.meta.title) }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="$vuetify.lang.t('$vuetify.menu.' + item.meta.title)"
                  />
                </v-list-item-content>
              </template>
              <v-list-item
                :class="drawerWidth === 64 ? 'pl-4' : ''"
                v-for="subItem in item.children"
                :key="subItem.name"
                :to="subItem.path"
                v-show="!subItem.meta.hiddenInMenu"
              >
                <template v-if="drawerWidth === 64">
                  <v-list-item-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          v-text="subItem.meta.icon"
                        />
                      </template>
                      <span>{{
                        $vuetify.lang.t('$vuetify.menu.' + subItem.meta.title)
                      }}</span>
                    </v-tooltip>
                  </v-list-item-icon>
                </template>
              </v-list-item>
            </v-list-group>
          </template> -->
          <template>
            <v-list-item
              :key="key"
              :to="item.path"
              v-if="canAccessItem(item)"
            >
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" v-text="item.meta.icon" />
                  </template>
                  <span>{{
                    $vuetify.lang.t('$vuetify.menu.' + item.meta.title)
                  }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-text="$vuetify.lang.t('$vuetify.menu.' + item.meta.title)"
                />
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import { sectionMenu } from '@/router/nav-model'
import { canAccess } from '@/router/access'
import AppLauncher from '@/components/nav/AppLauncher.vue'

export default {
  name: 'ReportsDrawer',
  components: { AppLauncher },
  data() {
    return {
      drawer: true,
      mini: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['getUser']),
    computeMenu() {
      // Antes: `[home, ...routes[1].children]` — acoplado al índice del array y
      // mezclando una entrada de otra sección (Inicio) dentro de este drawer.
      return sectionMenu('reports', this.getUser)
    },
  },
  methods: {
    canAccessItem(item) {
      return canAccess(item, this.getUser)
    },
  },
}
</script>

<style>

</style>
